// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseProdConfig = {
  apiKey: "AIzaSyA_DS2Gx38IZFkgjWaxwTJrf2XxGoCIyHk",
  authDomain: "rorender-38b6b.firebaseapp.com",
  projectId: "rorender-38b6b",
  storageBucket: "rorender-38b6b.appspot.com",
  messagingSenderId: "149823502279",
  appId: "1:149823502279:web:be4fd2bea0ff14fc4f0be2",
  measurementId: "G-L7KBZXYPVX"
};

export const firebaseDevConfig = {
  apiKey: "AIzaSyBlw3pHCZuus0_bnFiiHMQtWldXko3gMKU",
  authDomain: "dev-rorender.firebaseapp.com",
  projectId: "dev-rorender",
  storageBucket: "dev-rorender.firebasestorage.app",
  messagingSenderId: "949461714090",
  appId: "1:949461714090:web:cf2f8e5ac0f6c6bea2bcd3",
  measurementId: "G-YZWQLTM8RG"
}
